import { QueryClient } from '@tanstack/react-query'

export const NEWS_KEY = 'news'

export const newsQueryKeys = {
  all: [NEWS_KEY] as const,
  feed: () => [NEWS_KEY, 'feed'] as const,
  postAll: () => [NEWS_KEY, 'post'] as const,
  post: (postId: number | null) => [NEWS_KEY, 'post', postId] as const,
  // Split deliberately: the count is per-user, but every invalidation targets the prefix so it
  // does not need to know whose count it is. The `since` timestamp is never part of the key, so a
  // refetch always reads the current one rather than resurrecting a cache entry keyed to an old.
  unreadCountAll: () => [NEWS_KEY, 'unread-count'] as const,
  unreadCount: (userId: number | undefined) => [NEWS_KEY, 'unread-count', userId] as const,
  attachmentUrl: (postId: number, attachmentId: number) => [NEWS_KEY, 'attachment-url', postId, attachmentId] as const,
}

export const newsCacheRoots = [newsQueryKeys.feed(), newsQueryKeys.postAll(), newsQueryKeys.unreadCountAll()] as const

export async function invalidateNewsCaches(queryClient: QueryClient): Promise<void> {
  await Promise.all(newsCacheRoots.map((queryKey) => queryClient.invalidateQueries({ queryKey })))
}
